import React, { useEffect, useState } from "react";

import classes from "./StudentsLayout.module.css"
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { submissionStatisticApi } from '../../../../../utils'
import { throwApiError } from "../../../../lms-shared/store/error-handling-actions";
import { fetchTopicsData } from "../../../../../store/topic-actions";
import useSortAssessmentsByToc from '../../../../lms-shared/hooks/useSortAssessmentsByToc'
import HotMap from "./HotMap/HotMap";
import Graphs from "./Graphs/Graphs";
import * as SubmissionStatus from "../../../../lms-shared/models/SubmissionStatus";

const StudentsLayout = () => {
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);
    const { lessonByTopic } = useSelector(state => state.topics)
    const { guid, id } = useParams();
    const dispatch = useDispatch()
    const SortAssessments = useSortAssessmentsByToc()
    const [studentsSubmmissionList, setStudentsSubmmissionList] = useState()


    function fetchStudentLayoutData() {
        if (guid !== "0") {
            const data =
            {
                studyGroupId: id,
                toCId: guid
            }
            submissionStatisticApi.submissionStatisticsHotMapPost({ submissionStatisticInput: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.submissionsAllStudentsStatisticError, error: error, statusCode: response?.statusCode, message: "submissionsAllStudentsStatisticPost " + error.message, level: 2, component: "StudentsLayout", line: 35 }))
                }
                else {

                    const isSubmissionSubmit = (stuatus) => {
                        return [SubmissionStatus.completed, SubmissionStatus.submitted, SubmissionStatus.resubmitted, SubmissionStatus.scored].includes(stuatus); // true
                    }

                    let studentSubmissionsObj = {}
                    studentSubmissionsObj.students = resdata.users.map(user => {
                        const studentSubmissions = {};
                        user.assessments.forEach(assessment => {
                            studentSubmissions[assessment.id] = {
                                score: assessment.submission?.score,
                                status: assessment.submission?.submissionStatusId,
                            }
                        })

                        const fileresAssesssments = user.assessments.filter(user => user.submission?.score);
                        let studentScoreAverage
                        if (fileresAssesssments.length > 0)
                            studentScoreAverage = fileresAssesssments.reduce((total, next) => total + next.submission.score, 0) / fileresAssesssments.length;

                        return {
                            id: user.id,
                            firstName: user.firstName,
                            lastName: user.lastName,
                            submissions: studentSubmissions,
                            studentScoreAverage: studentScoreAverage
                        }
                    })

                    const allAssessments = resdata.users.flatMap((user) => user.assessments)
                    const assessmentDis = allAssessments.reduce((assessmentDis, assessment) => {
                        if (!assessmentDis[assessment.id]) {
                            assessmentDis[assessment.id] = {
                                ...assessment,
                                count: assessment.submission?.score ? 1 : 0,
                                sumScore: assessment.submission?.score ? assessment.submission.score : 0,
                                countSubmissionSubmit: assessment.submission && isSubmissionSubmit(assessment.submission.submissionStatusId) ? 1 : 0,
                                countSubmmission: 1
                            };
                            return assessmentDis;
                        }

                        if (assessment.submission?.score) {
                            assessmentDis[assessment.id].sumScore = assessmentDis[assessment.id].sumScore += assessment.submission.score;
                            assessmentDis[assessment.id].count = assessmentDis[assessment.id].count + 1;
                        }
                        assessmentDis[assessment.id].countSubmmission = assessmentDis[assessment.id].countSubmmission + 1;
                        if (assessment.submission && isSubmissionSubmit(assessment.submission.submissionStatusId))
                            assessmentDis[assessment.id].countSubmissionSubmit = assessmentDis[assessment.id].countSubmissionSubmit + 1;
                        return assessmentDis;
                    }, {});

                    studentSubmissionsObj.assessments = Object.keys(assessmentDis).map(assesmentId => {
                        const assesment = assessmentDis[assesmentId];
                        return {
                            id: assesment.id,
                            lessonId: assesment.lessonId,
                            name: assesment.name,
                            avgScore: assesment.count > 0 ? assesment.sumScore / assesment.count : assesment.sumScore,
                            AvgSubmissions: assesment.countSubmissionSubmit / assesment.countSubmmission
                        }
                    })
                    if (!resdata.isLesson)
                        studentSubmissionsObj.assessments = SortAssessments(studentSubmissionsObj.assessments, lessonByTopic)
                    setStudentsSubmmissionList(studentSubmissionsObj)
                }
            })
        }
    }

    useEffect(() => {
        if (lessonByTopic) {
            fetchStudentLayoutData()
        }
    }, [guid, lessonByTopic]);

    return (
        <div className={`${classes.StudentsLayoutWrapper} ${classes[direction]}`}>
            <div className={`${classes.StudentsLayoutContainer}`}>
                {studentsSubmmissionList && <Graphs studentsSubmmissionList={studentsSubmmissionList}></Graphs>}
                {studentsSubmmissionList && <HotMap studentsSubmmissionList={studentsSubmmissionList} ></HotMap>}
            </div>
        </div >
    )
}

export default StudentsLayout;